﻿import type { XylView } from "@grindex-client/common/js/helpers/xyl-view-helpers";

export function asyncModules(moduleName: string, eventName: string, callback: XylView["init"]) {
	window.addEventListener(eventName, moduleLoaded);

	function moduleLoaded() {
		const $views = [...document.querySelectorAll<HTMLElement>(`[xyl-async-view="${moduleName}"]`)];

		callback($views);
	}
}

export function asyncModule(moduleName: string, eventName: string, callback: (views: HTMLElement) => void) {
	window.addEventListener(eventName, moduleLoaded);

	function moduleLoaded() {
		const $views = [...document.querySelectorAll<HTMLElement>(`[xyl-async-view="${moduleName}"]`)];

		for (const $module of $views) {
			callback($module);
		}
	}
}

/**
 * @deprecated Use the asyncModule function instead. This function will be removed in a future release.
 */
export default asyncModule;
